module.exports = __webpack_public_path__ + "assets/img/显示器.e9c4e0e1.png";